import VPageReservationList from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageReservationList', VPageReservationList),
};
